/**
 * @file Nvigation.
 */

import { gsap } from 'gsap';

/**
 *
 * Open / close mobile nav.
 *
 * @package
 * @author  Vitamin
 * @version 1.0.0
 */
const vNav = () => {
	const { body } = document;
	const burger   = document.querySelector('.v-header__hamburger');
	const nav      = document.querySelector('.v-nav--mobile');

	/**
	 *
	 */
	function toggleMenu() {
		if (!body.classList.contains('menu-open')) {
			nav.classList.add('open');
			nav.setAttribute('aria-hidden', false);
			nav.setAttribute('aria-label', 'mobile navigation open');
			body.style.overflowY = 'hidden';
			nav.style.overflowY  = 'scroll';

			body.classList.add('menu-open');
			gsap.fromTo(nav, {
				opacity: 0,
			}, {
				opacity:  1,
				duration: 0.2,
			});
		} else {
			gsap.fromTo(nav, {
				opacity: 1,
			}, {
				opacity:    0,
				duration:   0.2,
				onComplete: () => {
					nav.classList.remove('open');
					nav.setAttribute('aria-hidden', true);
					nav.setAttribute('aria-label', 'mobile navigation');
					body.removeAttribute('style');
					nav.removeAttribute('style');
					body.classList.remove('menu-open');
					nav.removeAttribute('style');
				},
			});
		}
	}

	burger.addEventListener('click', toggleMenu);
};

export default vNav;
